import config from '../Config.js';

/**
 * 
 * @returns 
 */
export function getMerchantsWithUrbantzTokens(data) {
    return fetch(config.hostApi + 'merchants/urbantztokens', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(data)
    })
}

/**
 * 
 * @returns 
 */
export function saveUrbantzToken(data) {
    return fetch(config.hostApi + 'merchant/urbantztoken', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(data)
    })
}

/**
 * 
 * @returns 
 */
export function updateUrbantzToken(id, data) {
    return fetch(config.hostApi + 'merchant/' + id + '/urbantztoken', {
        method: 'PUT',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(data)
    })
}

/**
 * 
 * @returns 
 */
export function getOneMerchantWithUrbantzTokens(id) {
    return fetch(config.hostApi + 'merchant/' + id + '/urbantztoken', {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
    })
}

/**
 * 
 * @returns 
 */
export function deleteUrbantzTokens(id) {
    return fetch(config.hostApi + 'merchant/' + id + '/urbantztoken', {
        method: 'DELETE',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
    })
}

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function getManyNetworks(data) {
    return fetch(config.hostApi + 'networks', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(data)
    });
}

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function getManyMerchants(data) {
    return fetch(config.hostApi + 'merchants', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(data)
    })
}

/**
 * 
 * @param {*} id 
 */
export function getOneNetwork(id) {
    return fetch(config.hostApi + 'network/' + id, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
    })
}
